import { useState } from "react";

const CATS = ["明星动态", "影视娱乐", "音乐现场", "体坛竞技", "社会奇闻", "生活百态", "其他"];

type Status = { type: "idle" | "success" | "error"; msg: string };

const FORM_ACTION = "https://readdy.ai/api/form/daf7rrptto0ceqqnh7cg";

export default function ContactForm() {
  const [status, setStatus] = useState<Status>({ type: "idle", msg: "" });
  const [textLen, setTextLen] = useState(0);

  async function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    const form = e.currentTarget;

    const pot = new FormData(form).get("website_alt") as string;
    // 蜜罐命中：不真正提交，返回与正常一致的成功提示
    if (pot && pot.trim() !== "") {
      setStatus({ type: "success", msg: "已收到，感谢你的线索！我们核实后会尽快跟进。" });
      return;
    }

    const payload = new FormData(form);
    try {
      const res = await fetch(FORM_ACTION, { method: "POST", body: payload });
      const responseText = await res.text();
      let parsed: any = null;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }
      const serverMsg =
        parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText;
      const isSpam = typeof serverMsg === "string" && serverMsg.toLowerCase().includes("spam");

      if (res.ok && parsed?.code === "OK") {
        setStatus({ type: "success", msg: "已收到，感谢你的线索！我们核实后会尽快与你联系。" });
        form.reset();
        setTextLen(0);
      } else {
        const errMsg = isSpam ? "提交内容被系统判定为异常，请稍后再试。" : serverMsg || "提交失败，请稍后重试。";
        setStatus({ type: "error", msg: String(errMsg) });
      }
    } catch {
      setStatus({ type: "error", msg: "网络开小差了，提交失败，请稍后重试。" });
    }
  }

  return (
    <section id="contact" className="scroll-mt-20 bg-cream-50 py-14 md:py-20">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="overflow-hidden rounded-3xl border border-cream-200 bg-white">
          <div className="grid lg:grid-cols-[0.9fr_1.1fr]">
            <div className="relative bg-stone-900 p-7 text-white md:p-9">
              <div className="pointer-events-none absolute -right-16 -top-16 h-48 w-48 rounded-full bg-coral-500/20 blur-3xl"></div>
              <h2 className="text-2xl font-black md:text-3xl">我要爆料</h2>
              <p className="mt-3 max-w-sm text-sm leading-relaxed text-stone-300">
                吃到一手瓜，或发现了值得全网讨论的今日新鲜事？欢迎把你的线索告诉我们。编辑部会优先跟进信息完整、有公开佐证的投稿。
              </p>
              <ul className="mt-7 space-y-3 text-sm">
                <li className="flex items-start gap-3">
                  <span className="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-white/10 text-coral-300">
                    <i className="ri-mail-line" aria-hidden="true"></i>
                  </span>
                  <div>
                    <p className="font-semibold">投稿邮箱</p>
                    <p className="text-stone-300">tougao@chiagua.cn（示例）</p>
                  </div>
                </li>
                <li className="flex items-start gap-3">
                  <span className="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-white/10 text-leaf-300">
                    <i className="ri-time-line" aria-hidden="true"></i>
                  </span>
                  <div>
                    <p className="font-semibold">跟进时效</p>
                    <p className="text-stone-300">工作日通常在 24 小时内回复</p>
                  </div>
                </li>
                <li className="flex items-start gap-3">
                  <span className="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-white/10 text-coral-300">
                    <i className="ri-shield-check-line" aria-hidden="true"></i>
                  </span>
                  <div>
                    <p className="font-semibold">信息原则</p>
                    <p className="text-stone-300">仅核实公开来源，传播前会与投稿人确认</p>
                  </div>
                </li>
              </ul>
            </div>

            <div className="p-7 md:p-9">
              <form
                data-readdy-form="吃瓜爆料投稿表单"
                onSubmit={handleSubmit}
                className="grid grid-cols-1 gap-4 sm:grid-cols-2"
                noValidate
              >
                <div>
                  <label htmlFor="contact-name" className="mb-1.5 block text-sm font-semibold text-stone-700">
                    怎么称呼你
                  </label>
                  <input
                    id="contact-name"
                    name="name"
                    type="text"
                    required
                    maxLength={20}
                    placeholder="你的昵称"
                    className="w-full rounded-lg border border-cream-300 bg-cream-50 px-3.5 py-2.5 text-sm text-stone-700 outline-none transition placeholder:text-stone-400 focus:border-coral-400 focus:bg-white focus:ring-2 focus:ring-coral-100"
                  />
                </div>
                <div>
                  <label htmlFor="contact-cat" className="mb-1.5 block text-sm font-semibold text-stone-700">
                    属于哪个栏目
                  </label>
                  <select
                    id="contact-cat"
                    name="category"
                    defaultValue={CATS[1]}
                    className="w-full rounded-lg border border-cream-300 bg-cream-50 px-3 py-2.5 text-sm text-stone-700 outline-none transition focus:border-coral-400 focus:bg-white focus:ring-2 focus:ring-coral-100"
                  >
                    {CATS.map((c) => (
                      <option key={c} value={c}>
                        {c}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="sm:col-span-2">
                  <label htmlFor="contact-title" className="mb-1.5 block text-sm font-semibold text-stone-700">
                    爆料标题
                  </label>
                  <input
                    id="contact-title"
                    name="title"
                    type="text"
                    required
                    maxLength={60}
                    placeholder="一句话概括你的线索，例如：某城市快闪店排长队走红"
                    className="w-full rounded-lg border border-cream-300 bg-cream-50 px-3.5 py-2.5 text-sm text-stone-700 outline-none transition placeholder:text-stone-400 focus:border-coral-400 focus:bg-white focus:ring-2 focus:ring-coral-100"
                  />
                </div>

                <div className="sm:col-span-2">
                  <label htmlFor="contact-content" className="mb-1.5 flex items-center justify-between text-sm font-semibold text-stone-700">
                    <span>线索详情</span>
                    <span className="text-xs font-normal text-stone-400">{textLen} / 500</span>
                  </label>
                  <textarea
                    id="contact-content"
                    name="content"
                    required
                    maxLength={500}
                    rows={5}
                    onChange={(e) => setTextLen(e.target.value.length)}
                    placeholder="请尽量补充时间、地点、可公开的佐证或链接，方便我们跟进核实…"
                    className="w-full resize-none rounded-lg border border-cream-300 bg-cream-50 px-3.5 py-2.5 text-sm leading-relaxed text-stone-700 outline-none transition placeholder:text-stone-400 focus:border-coral-400 focus:bg-white focus:ring-2 focus:ring-coral-100"
                  ></textarea>
                </div>

                <div className="sm:col-span-2">
                  <label htmlFor="contact-email" className="mb-1.5 block text-sm font-semibold text-stone-700">
                    联系方式（用于采用后联系你）
                  </label>
                  <input
                    id="contact-email"
                    name="email"
                    type="email"
                    required
                    placeholder="name@example.com"
                    className="w-full rounded-lg border border-cream-300 bg-cream-50 px-3.5 py-2.5 text-sm text-stone-700 outline-none transition placeholder:text-stone-400 focus:border-coral-400 focus:bg-white focus:ring-2 focus:ring-coral-100"
                  />
                </div>

                {/* 蜜罐字段：对人类隐藏，避免机器人灌水 */}
                <input
                  className="contact-pot-field"
                  type="text"
                  name="website_alt"
                  tabIndex={-1}
                  autoComplete="off"
                  aria-hidden="true"
                  readOnly
                />

                <div className="sm:col-span-2">
                  {status.type === "success" && (
                    <p className="mb-3 flex items-center gap-2 rounded-lg bg-leaf-50 px-3.5 py-2.5 text-sm text-leaf-700">
                      <i className="ri-checkbox-circle-line" aria-hidden="true"></i>
                      {status.msg}
                    </p>
                  )}
                  {status.type === "error" && (
                    <p className="mb-3 flex items-start gap-2 rounded-lg bg-coral-50 px-3.5 py-2.5 text-sm text-coral-700">
                      <i className="ri-error-warning-line mt-0.5" aria-hidden="true"></i>
                      {status.msg}
                    </p>
                  )}
                  <button
                    type="submit"
                    className="inline-flex w-full items-center justify-center whitespace-nowrap rounded-full bg-coral-500 px-6 py-3 text-sm font-semibold text-white transition hover:bg-coral-600 focus:outline-none focus:ring-2 focus:ring-coral-300 focus:ring-offset-2 sm:w-auto"
                  >
                    <i className="ri-send-plane-line mr-1.5" aria-hidden="true"></i>提交爆料线索
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}